import React, { Component, Fragment } from 'react';

import { restRequest } from '../../../../Helpers/RequestHelper';
import getDate from '../../../../Helpers/Date/GetDate';
import {
  getObjFromLS,
  //getStringValueFromLS,
  setObjInLS,
  setValueInLS,
} from '../../../../Helpers/LocalStorage';
import { NewItemAdjustmentIcon } from '../../../../Assets/Navigation/NavigationIcons';

import HeaderWrapper from '../../../../Components/HeaderWrapper/HeaderWrapper';
import Box from '../../../../Components/Layout/Box';
import { ActionMenu } from '../../../../Components/CheckedMenu/CheckedMenu';
import ListTableImageColumn from '../../../../Components/ListTable/ListTableImageColumn';
import Table from '../../../../Components/Table/Table';
import { MdClose } from '../../../../Common/Icons';
import Loader from '../../../../Components/Loader/Loader';
import NotFound from '../../../../Components/NotFound/NotFound';
import { checkError } from '../../../../Helpers/AuthHelper';
import { HeaderMenus } from '../../../../Components';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';

class ItemAdjustmentDetails extends Component {
  id = this.props.idFromHeaderWrapper
    ? this.props.idFromHeaderWrapper
    : this.props.match.params.id;
  state = {
    itemAdjustment: {},
    loading: true,
    notFound: false,
    detailsNo: this.props.t('Items.adjustment_summary'),
  };

  componentDidMount() {
    document.title = this.props.t('Items.item_adjustment_details');
    this.fetchData();
  }

  async fetchData() {
    this.setState({ loading: true });
    await restRequest('get', `itemadjustments/${this.id}`)
      .then((res) => {
        this.setState({
          itemAdjustment: res,
          detailsNo: this.state.detailsNo,
          loading: false,
        });
        let dataFromLS = getObjFromLS('module');
        setObjInLS('module', {
          ...dataFromLS,
          presistDetailPage: true,
        });
      })
      .catch((err) => {
        checkError(err);
        this.setState({ notFound: true, loading: false });
      });
  }

  renderActionMenu() {
    const hasDeletePermission = this.hasPermission('itemadjustment', 'Delete');
    const menusList = [
      {
        type: 'button',
        icon: 'delete',
        tooTip: this.props.t('Items.delete'),
        mobileLable: this.props.t('Items.delete'),
        isMobile: true,
        handleClick: () =>
          this.openDeleteModal(
            this.id,
            this.props.forceRedirect,
            this.props.forceRedirectFlag
          ),
        enable: hasDeletePermission,
      },
      {
        type: 'button',
        className: 'button--primary float-left mr-3',
        handleClick: () => this.props.history.push(`/item-adjustments/add`),
        label: this.props.t('Items.new'),
        icon: 'new',
      },
    ];
    return (
      <ActionMenu>
        <HeaderMenus menusList={menusList} loading={this.state.loading} />
      </ActionMenu>
    );
  }
  renderAccountandAditionalInfo() {
    const { itemAdjustment } = this.state;

    const account = itemAdjustment?.account || {};
    const accountGroup = account?.account_group || {};
    const adjustedBy = itemAdjustment?.item_adjustment_created_by?.name || '-';
    const date = itemAdjustment?.adjustment_date || '';
    const description = itemAdjustment?.description || '-';
    const reason = itemAdjustment?.reason || '-';
    const warehouse_name = itemAdjustment?.warehouse_name || '-';
    const adjustmentType = itemAdjustment?.adjustment_type || '-';
    const title = account?.title || '-';
    const groupName = accountGroup?.name;

    return (
      <div className="adjustment_details">
        <div className="section-details--info">
          <div className="field-row">
            <div className="section-details--info-title semi-bold heading_font">
              {this.props.t('Items.adjusted_by')}
            </div>
            <div className="semi-bold">{adjustedBy}</div>
          </div>
          <hr className="bottom_line" />

          <div className="field-row">
            <div className="adjust_date section-details--info-title semi-bold heading_font">
              {this.props.t('Items.adjustment_date')}
            </div>
            <div>{getDate(date)}</div>
          </div>
          <hr className="bottom_line" />

          <div className="field-row">
            <div className="section-details--info-title semi-bold heading_font">
              {this.props.t('Items.account')}
            </div>
            <div className="semi-bold">{title}</div>
          </div>
          <hr className="bottom_line" />

          {groupName && (<> <div className="field-row">
            <div className="section-details--info-title semi-bold heading_font">
              {this.props.t('Items.account_group')}
            </div>
            <div>{groupName}</div>
          </div>
            <hr className="bottom_line" />
          </>)}

          <div className="field-row">
            <div className="section-details--info-title semi-bold heading_font">
              {this.props.t('Items.type')}
            </div>
            <div className="capitalize">
              {adjustmentType === 'quantity'
                ? t('ListTable.quantity')
                : adjustmentType}
            </div>
          </div>
          <hr className="bottom_line" />

          <div className="field-row">
            <div className="section-details--info-title semi-bold heading_font">
              {this.props.t('Items.warehouse')}
            </div>
            <div className="capitalize">
              <span>{warehouse_name}</span>
            </div>
          </div>
          <hr className="bottom_line" />

          <div className="section-details--info-title semi-bold heading_font">
            {this.props.t('Items.reason')}
          </div>
          <div className="word-break">{reason}</div>

          <hr className="bottom_line" />

          <div className="section-details--info-title semi-bold heading_font">
            {this.props.t('Items.description')}
          </div>
          <div className="word-break">{description}</div>
        </div>
      </div>
    );
  }

  renderLayoutView() {
    // const { itemAdjustment } = this.state
    // const { item_adjustment_created_by: {name: adjustedBy} } = itemAdjustment

    return (
      <Fragment>
        <div className="float-left w-100 adjustment_summary_update position-relative">
          <div className="close_icon">
            <MdClose
              onClick={() => {
                let dataFromLS = getObjFromLS('module');
                setObjInLS('module', {
                  ...dataFromLS,
                  presistDetailPage: false,
                });
                setValueInLS('fullscreen', 'true');
                sessionStorage.setItem('once', true);

                this.props.history.push('/r');
              }}
            />
          </div>
          {this.renderAccountandAditionalInfo()}
        </div>
      </Fragment>
    );
  }

  prepareAdjustmentItemsData(items) {
    return items.map((item) => ({
      name: (
        <ListTableImageColumn
          name={item?.item?.item_name}
          sku={item?.item?.sku}
          images={item?.item?.images}
          id={item?.item_id}
          showModalUponClick
        />
      ),

      adjustedAmount: `${item?.adjusted_amount} ${item?.item.unit ? item.item.unit : ''
        }`,
    }));
  }

  renderSidebar() {
    const preparedData = this.prepareAdjustmentItemsData(
      this.state.itemAdjustment.item_adjustment_details
    );

    const tableHeaders = [
      this.props.t('Items.item'),
      this.props.t('Items.adjusted'),
    ];
    const tableData = ['name', 'adjustedAmount'];
    const rightAlignColumns = [2];
    return (
      // <Box  className="no-padding-body itemstab">

      <Box className="itemstab item_adjustment_table">
        <div className="height_custom_adjustment scrollbar_style">
          <Table
            list={preparedData}
            tableHeaders={tableHeaders}
            tableData={tableData}
            rightAlignColumns={rightAlignColumns}
            className="details-table"
          />
        </div>
      </Box>
    );
  }

  render() {
    if (this.state.loading) return <Loader />;
    if (this.state.notFound) return <NotFound />;
    return (
      // <GridLayout>
      //   <Grid>{this.renderLayoutView()}</Grid>
      //   <Grid transparent>{this.renderSidebar()}</Grid>
      // </GridLayout>
      <Fragment>
        {this.renderLayoutView()}
        {this.renderSidebar()}
      </Fragment>
    );
  }
}

export default withTranslation()(
  HeaderWrapper(ItemAdjustmentDetails, {
    name: 'Items.item_adjustments', // name prop is used in headerwrapper change in name also need to change in headerwrapper as well
    tableIcon: 'general_module_icon icon_top',
    deleteName: 'Item Adjustment',
    deleteText: 'item_adjustment',
    Icon: NewItemAdjustmentIcon,
    baseUrl: 'itemadjustments',
    redirectUrl: '/item-adjustments',
    onlyMenu: true,
    showName: true,
    permissionName: 'itemadjustment',
  })
);
